<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-22 00:07:12
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-01 16:31:56
 * @FilePath: \H5\src\views\bottom.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="button">
    <div class="left" :style="{ backgroundImage: `url(${bgImageUrl})` }">
      <div class="f-box" @click="hTil">
        <div class="phone">
          <img
            src="../assets/images/pheIC.png"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
        <div>客服</div>
      </div>
    </div>
    <div
      class="right"
      @click="hGo"
      :style="{ backgroundImage: `url(${bgImageUrl2})` }"
    >
      <!-- <img src="../assets/images/底部左侧按钮.png" alt="" /> -->
      <div class="r-text">去店铺逛逛</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      recommend_role: 0,
      list: null,
      phone: "",
      ag: "",
      bgImageUrl: require("../assets/images/phe.png"),
      bgImageUrl2: require("../assets/images/bbtn.png"),
    };
  },
  created() {
    this.list = JSON.parse(window.localStorage.getItem("reData"));
    console.log(this.list, "bbbbbb");
    this.phone = this.list.phone;
    this.recommend_role = this.list.recommend_role;
    this.ag = this.list.ag;

    this.hFlag();
  },
  methods: {
    hFlag() {
      if (this.recommend_role == 0) {
        this.bgImageUrl = require("../assets/images/phe.png");
        this.bgImageUrl2 = require("../assets/images/bbtn.png");
      } else if (this.recommend_role == 1) {
        this.bgImageUrl = require("../assets/images/phe2.png");
        this.bgImageUrl2 = require("../assets/images/bbtn2.png");
      } else if (this.recommend_role == 2) {
        this.bgImageUrl = require("../assets/images/phe3.png");
        this.bgImageUrl2 = require("../assets/images/bbtn3.png");
      }
    },
    hTil() {
      window.location.href = "tel:" + this.phone;
    },
    async hGo() {
      if (this.list.jump_link_type == 1) {
        let data = {
          merchant_id: this.list.wx_merchant_id,
          path: `${this.list.jump_link}?product=${this.list.product_id}&ag=${this.ag}&m_id=${this.list.model_id}&merchant_id=${this.list.merchant_id}&st=1`,
        };
        await axios
          .post(
            "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/api/myshop/TraceCreateWXScheme",
            data
          )
          .then((res) => {
            console.log(res.data);
            if (res.data.message.code === 200) {
              location.href = res.data.data.openlink;
            }
          });
      } else {
        location.href = this.list.jump_link;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  left: 15%;
  display: flex;
  position: fixed;
  bottom: 10px;
  z-index: 1;
  margin: 0 auto;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 82px;
    // background: url("../assets/images/phe.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .f-box {
      font-size: 28px;
      font-weight: bold;

      opacity: 1;
      display: flex;
      .phone {
        margin-top: 6px;
        margin-left: 8px;
        width: 27.8px;
        height: 27.8px;
      }
    }
  }

  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 377px;
    height: 82px;
    // background: url("../assets/images/bbtn.png");
    margin-left: -35px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .r-text {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>